<template>
  <select>
    <option v-for="(item, index) in this.options" :key="index" :value="item.value">{{item.label ? item.label : item.value}}</option>
  </select>  
</template>
<script>
export default {
  name: "SelectOption",
  props: ['options']  
};
</script>
